import React, { useEffect } from 'react';
import CouponBets from 'Components/HorseRacing/CouponBets';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import Modal from 'Components/Modal';
import { useSelector } from 'react-redux';
import { oddFormatter } from 'Utils/decimalFormatter';
import { decimalFormatterLast } from 'Utils/decimalFormatter';
import { withMixpanel } from 'Utils/mixpanel';

const SystemDetail = ({ onCLose, mixpanel }) => {
  const { systemDetail, error } = useSelector(state => state.horseRacing.coupons);

  const getAmount = fixedOddModel => {
    if (fixedOddModel?.startingPrice) {
      return '-';
    }
    if (fixedOddModel?.expectedWinAmount) {
      return `${decimalFormatterLast(fixedOddModel?.expectedWinAmount)} TL`;
    }
    return '-';
  };

  useEffect(()=> {
    if (systemDetail?.systemSelections?.length > 0) {
      const { source, systemSelections } = systemDetail;
      mixpanel.track('TJK Click System on Coupon', {
        Source: source,
        SelectedSystems: systemSelections?.join(','),
      });
    }
  }, [systemDetail]);

  return (
    <Modal
      title={ `Sistem ${error ? '' : `(${systemDetail?.systemSelections?.join(',') || ''})`}` }
      centered
      modalSize="large"
      className="hr-system-detail-modal"
      onClose={ onCLose }>
      <div className="hr-system-detail">
        <div className={ classnames({
          'hr-system-detail__info': true,
          'has-error': error
        }) }>
          { error || 'Sistem kuponundaki tüm kombinasyonları görüyorsun.' }
        </div>
        {
          !error && systemDetail?.coupons?.map(coupon => {
            const isWin = coupon?.parlayCouponLegs?.every(l => l?.status === 'WON');
            const isLost = coupon?.parlayCouponLegs?.some(l => l?.status === 'LOST');
            const isUnElevated = coupon?.parlayCouponLegs?.some(l => l?.status === 'UNEVALUATED');
            return <div className="hr-system-detail__coupon" key={ coupon?.couponId }>
              { coupon?.parlayCouponLegs && <CouponBets couponLegs={ coupon?.parlayCouponLegs }/> }
              <div className="hr-system-detail__coupon-footer">
                <div>
                  <span>
                  Toplam Oran
                  </span>
                  <span>
                    { coupon?.fixedOddModel?.startingPrice ? 'K.O' : oddFormatter(coupon?.fixedOddModel?.fixedOdd) }
                  </span>
                </div>
                <div>
                  <span>Tahmini Kazanç</span>
                  <span
                    className={ classnames({
                      winner: isWin,
                      lost: isLost,
                      'un-evaluated': isUnElevated
                    }) }>{ getAmount(coupon?.fixedOddModel) }</span>
                </div>
              </div>
            </div>;
          })
        }
      </div>
    </Modal>
  );
};

SystemDetail.propTypes = {
  onCLose: PropTypes.func,
  mixpanel: PropTypes.object,
};

export default withMixpanel(SystemDetail);
